import { flowRight } from 'lodash';
import * as m from './model';
import { NAME } from './constants';

export const model = (state) => state[NAME] || m.initialState;
export const getNotifications = flowRight([m.notifications, model]);
export const getNotificationsRefs = flowRight([m.notificationsRefs, model]);
export const getNotification = (state, refName) => getNotifications(state)[refName];
